import { Slide, ToastContainer } from "react-toastify";
// limit toast messages to 3 to get best user experience (remaining will be in queue)
export const Toast = () => {
  return (
    <ToastContainer
      position="top-center"
      hideProgressBar={true}
      limit={3}
      newestOnTop={true}
      closeOnClick={false}
      rtl={false}
      transition={Slide}
      draggable="touch"
      pauseOnHover={true}
      theme="colored"
    ></ToastContainer>
  );
};
